const out = console.log
import { Coord } from '../../models/Location/mapUtils'
declare var google: any

const windowShadePositions = ['min', 'mid', 'max']
function getVerticalScalingFactor(windowShadePosition) {
	const factors = [0, 0.25, 0]  // [0.334, 0, 0]
	return factors[windowShadePosition]
}

function adjustMapByPixelOffset(pixelCenter, xOffset, yOffset, scale, map) {
	const pixelOffset = new google.maps.Point((xOffset/scale) || 0, (yOffset/scale) || 0);
	const newCenter = {x: pixelCenter.x - pixelOffset.x, y: pixelCenter.y - pixelOffset.y};
	return new Coord(map.getProjection().fromPointToLatLng(new google.maps.Point(newCenter.x, newCenter.y)));
}

//getVerticalScalingFactor(windowShadeState)
/**
 * Adjust the center of the map so that it is not hidden by the dropdown.
 * @param center: unadjusted center (probably returned by find_bounds_center)
 * @returns {*} adjusted center
 */
function adjustCenterByFactor(center, map, verticalFactor) {
	if (!map)	return center
	const projection = map.getProjection()
	if (!projection) return center

	let newCenter = new Coord(center);
	const mapCenter = projection.fromLatLngToPoint(new google.maps.LatLng(center.lat, center.lng));
	if (mapCenter.x && mapCenter.y) {
		// http://stackoverflow.com/questions/10656743/how-to-offset-the-center-point-in-google-maps-api-v3
		const scale = Math.pow(2, map.getZoom());
		//const dimensions = getMapDimensions(map);
		const mapHeight = window.innerHeight
		const mapWidth = window.innerWidth
		const yOffset = mapHeight * verticalFactor
		const xOffset = 0; // only adjusting vertically for now --- mapWidth * horizontalScalingFactor
		newCenter = adjustMapByPixelOffset(mapCenter, xOffset, yOffset, scale, map);
	}

	const adjustment = new Coord(newCenter.lat - center.lat, newCenter.lng - center.lng);
	//out('Center adjusted by: (lat: ' + adjustment.lat + ', lng: ' + adjustment.lng + ') to:', newCenter);
	return newCenter
}

function getMapDimensions(map) {
	const x = map.offsetWidth
	const y = map.offsetHeight
	//const y = Math.round(y/2);

	return {
		y, x,
		height: y,
		width: x,
	}
}

export { adjustCenterByFactor, getVerticalScalingFactor }



// WEBPACK FOOTER //
// ./src/app/components/SearchMap/utils.ts